<template>
    <div class="relative" :class="['fullscreen-wrapper', { fullscreen: isFullscreen }]">
        <div id="preview" v-if="selectedDocument">
            <div class="d-flex justify-content-between align-items-center"
                :style="{ padding: isFullscreen ? '.5rem' : '.1rem', marginBottom: isFullscreen ? '5px' : '0', backgroundColor: isFullscreen ? 'grey' : 'white', position: isFullscreen ? 'sticky' : 'static', zIndex: isFullscreen ? '99999' : '0', top: isFullscreen ? '-20px' : null }">
                <h6 class="mb-0" :style="{ color: isFullscreen ? 'white' : 'inherit' }">{{ title }}</h6>
                <button class="btn btn-sm" :class="{ 'btn-outline-primary': !isFullscreen }" @click="toggleFullscreen">
                    <template v-if="isFullscreen">
                        <div style="position:sticky;top:0"><i class="bi bi-fullscreen-exit me-2"></i><span>Wyjdź z trybu
                                pełnego ekranu</span></div>
                    </template>
                    <template v-else>
                        <div><i class="bi bi-fullscreen me-2"></i><span>Pełny ekran</span></div>
                    </template>
                </button>
            </div>
            <div>
                <ejs-grid ref="movementsGrid" id="movementsGridId" :height="isFullscreen ? '70vh' : '19vh'"
                    :dataSource="warehouseMovementsDataManager" :allowTextWrap="false" :allowExcelExport="true"
                    :allowPaging="true" :allowSorting="true" :allowFiltering="true" :allowReordering="true"
                    :allowResizing="true" :showColumnChooser="true" :allowSelection="true" :enablePersistence="true"
                    :actionComplete="actionComplete" :rowDataBound="rowDataBound" :pageSettings="pageSettings"
                    :editSettings="editSettings" :filterSettings="filterOptions" :toolbar="toolbar"
                    :rowSelected="onRowSelected" :toolbarClick="clickToolbarHandler"
                    :contextMenuItems="contextMenuItems" @cellEdit="cellEdit" :rowHeight="32"
                    :contextMenuClick="clickContextMenuHandler">
                    <e-columns>
                        <e-column field="id" headerText="ID" :allowEditing="false" isPrimaryKey="true"
                            :visible="false" />
                        <e-column field="document_number" headerText="Numer Dokumentu" :filter="filterDefault"
                            :allowEditing="false" />
                        <e-column field="previous_article_warehouse.short_name" headerText="Z Magazynu" type="string"
                            :filter="filterWarehouses" :allowEditing="false" />
                        <e-column field="article_warehouse.short_name" headerText="Na Magazyn" type="string"
                            :filter="filterWarehouses" :allowEditing="false" />
                        <e-column field="article.catalog_number" headerText="Nr artykułu" :filter="filterDefault"
                            :allowEditing="false" />
                        <e-column field="article.model" headerText="Model artykułu" :filter="filterDefault"
                            :allowEditing="false" />
                        <e-column field="article.description" headerText="Nazwa/Opis" width="200"
                            :filter="filterDefault" :allowEditing="false" />
                        <e-column field="article.article_unit.name" headerText="J.m." :visible="true"
                            :allowEditing="false" />
                        <e-column field="quantity" headerText="Ilość" type="number" :filter="filterDefault"
                            :allowEditing="!isDW()" />
                        <e-column field="article.price_netto_zl" headerText="Cena" type="number" width="200"
                            :filter="filterDefault" :allowEditing="true" />
                        <e-column field="article.location" headerText="Lokalizacja" type="string" width="200"
                            :filter="filterDefault" :allowEditing="true" />
                        <e-column field="producer_name" headerText="Producent" width="150" type="string"
                            :allowSorting="false" :allowFiltering="false" />
                        <e-column field="comment" headerText="Komentarz" type="string" :allowFiltering="false"
                            :allowSorting="false" :allowEditing="!isDW()" />
                        <e-column field="additional_comment" headerText="Dodatkowy komentarz" type="string"
                            :allowFiltering="false" :allowSorting="false" :allowEditing="isDW()" />
                        <e-column field="who_issuing" headerText="Osoba zlecająca" type="string" :filter="filterDefault"
                            :allowEditing="!isDW()" />
                        <e-column field="who_receiving" headerText="Osoba przyjmująca" type="string"
                            :filter="filterDefault" :allowEditing="true" />
                        <e-column field="purpose" headerText="Cel" type="string" :filter="filterDefault"
                            :allowEditing="!isDW()" />
                        <e-column field="created_by_name" headerText="Utworzony przez" :filter="filterDefault"
                            :allowEditing="false" />
                        <e-column field="created_at" headerText="Data utworzenia" format="dd.MM.yyyy"
                            :filter="filterDefault" :allowEditing="false" />
                        <e-column field="article.details" headerText="Sczegóły" type="text" width="200"
                            :filter="filterDefault" :allowEditing="false" />
                    </e-columns>
                </ejs-grid>
            </div>
            <AddItemMovementModal v-if="showAddItemMovementModal" ref="addItemMovementModalRef"
                :selectedMovement="selectedDocument" :selectedItemToClone="selectedItemToClone"
                @items-added="refreshGrid" :producers="producers" />
        </div>
    </div>
</template>
<script>
import { usePage } from "@inertiajs/vue3";
import { ColumnChooser, ColumnDirective, ColumnsDirective, ContextMenu, Edit, ExcelExport, Filter, ForeignKey, GridComponent, Page, Reorder, Resize, Sort, Toolbar, Group } from '@syncfusion/ej2-vue-grids';
import { createElement } from "@syncfusion/ej2-base";
import { DropDownList } from "@syncfusion/ej2-dropdowns";
import { DataManager, WebMethodAdaptor } from "@syncfusion/ej2-data";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import AddItemMovementModal from "./AddItemMovementModal.vue";
const { hasPermission, hasRole } = usePermission();
let dropInstanceFilterUnits, statusElem, statusObj;
export default {
    components: { AddItemMovementModal, 'ejs-grid': GridComponent, 'e-columns': ColumnsDirective, 'e-column': ColumnDirective },
    provide: { grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, Group] },
    props: {
        title: String,
        selectedDocument: Object,
        warehouses: Object,
        producers: Object,
		table_settings: {
		type: Object,
		now_restore_table_items: {
				type: Number,
				default: 1
				},
		default: null
		}
    },
    watch: {
        table_settings: {
            immediate: true,
            deep: true,
            handler(value) {
                this.hasTableSettingsSel = !!(value?.settings);
                this.$nextTick(() => {
                    this.refreshToolbar();
                });
            }
        },
        selectedDocument: {
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.getMovements(newVal);
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.$refs.movementsGrid?.ej2Instances?.refresh();
                            this.updateToolbarState();
                        }, 100);
                    });
                } else {
                    this.updateToolbarState();
                }
            }
        }
    },
    data() {
        return {
            hasTableSettingsSel: false,
            tableSettingsApplied: false,
			isEditing: false,
			hasSelectedRow: false,
            toolbar: [],
            isFullscreen: false,
            showAddItemMovementModal: false,
            warehouseMovementsDataManager: [],
            pageSettings: { pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000] },
            selectedMovement: null,
            selectedItemToClone: null,
            filterOptions: { type: "Menu", operator: "contains" },
            filterDefault: { operator: "contains", params: { minLength: 2 } },
            contextMenuItems: this.getContextMenu(),
            filterWarehouses: {
                operator: "contains",
                ui: {
                    create: (args) => {
                        let flValInput = createElement("input", { className: "flm-input" });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({ dataSource: this.warehouses, fields: { text: "short_name", value: "id" }, placeholder: "Szukaj magazynu", popupHeight: "200px", allowFiltering: true });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || "";
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },
            filterLocations: {
                operator: "contains",
                ui: {
                    create: (args) => {
                        let flValInput = createElement("input", { className: "flm-input" });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({ dataSource: this.locations, fields: { text: "short_name", value: "id" }, placeholder: "Szukaj magazynu", popupHeight: "200px", allowFiltering: true });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || "";
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },
            filterCreatedBy: {
                operator: "contains",
                ui: {
                    create: (args) => {
                        let flValInput = createElement("input", { className: "flm-input" });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({ dataSource: this.users, fields: { text: "name", value: "id" }, placeholder: "Szukaj kto stworzył", popupHeight: "200px", allowFiltering: true });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || "";
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },
            orderItemWarehousesParams: {
                create: () => {
                    statusElem = document.createElement("input");
                    return statusElem;
                },
                read: () => {
                    return statusObj.text;
                },
                destroy: () => {
                    statusObj.destroy();
                },
                write: () => {
                    statusObj = new DropDownList({
                        dataSource: this.warehouses, fields: { value: "id", text: "short_name" }, enabled: true, placeholder: "Wybierz magazyn", floatLabelType: "Never", change: async (event) => {
                            statusObj.value = await this.onChangeWarehouse(event);
                        }
                    });
                    statusObj.appendTo(statusElem);
                }
            }
        };
    },
    computed: {
        isClosed() {
            return this.selectedDocument?.closed === 1;
        },
        isDWDoc() {
            return this.selectedDocument?.document_number?.startsWith("DW");
        },
        canAdd() {
            return hasPermission("canViewWarehouseMovements") && !this.isClosed && !this.isDWDoc;
        },
        editSettings() {
            return {
                allowEditing: hasPermission("canViewWarehouseMovements") && !this.isClosed,
                allowAdding: hasPermission("canViewWarehouseMovements") && !this.isClosed && !this.isDWDoc,
                allowDeleting: hasPermission("canViewWarehouseMovements") && !this.isClosed,
                showConfirmDialog: false,
                showDeleteConfirmDialog: false,
                mode: "Batch",
                newRowPosition: "Top"
            };
        }
    },
    created() {
        this.toolbar = this.getToolbar();
    },
    methods: {
 	  restoreTableIfNeeded() {
		if (this.now_restore_table_items !== 0) {
		  return;
		}

		let grid = this.$refs.movementsGrid;

		if (!grid || !grid.$el || !grid.ej2Instances) {
		  return;
		}

		let gridName = 'grid' + grid.$el.id;

		grid.ej2Instances.enablePersistence = false;

		window.localStorage.setItem(gridName, "");

		grid.ej2Instances.destroy();

		(function stripIdsFromUrl() {
		  try {
			const url = new URL(window.location.href);

			url.searchParams.delete('ids');
			url.searchParams.delete('ids[]');

			history.replaceState(
			  history.state,
			  '',
			  url.toString()
			);
		  } catch (e) {
			const href = window.location.href;

			const cleaned = href
			  .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
			  .replace(/[?&]$/, '');

			history.replaceState(
			  history.state,
			  '',
			  cleaned
			);
		  }
		})();
		this.applyTableSettings();
		location.reload();
	  }, 
        applyTableSettings() {
            const grid = this.$refs.movementsGrid?.ej2Instances;

            if (!grid || !this.table_settings?.settings) {
                return;
            }


            let settings;

            try {
                settings = JSON.parse(this.table_settings.settings);
                console.log('wczytano ustawienia')
            } catch (error) {
                console.error('Błąd odczytu ustawień tabeli:', error);
                return;
            }

            if (!Array.isArray(settings)) {
                return;
            }

            settings.forEach(setting => {
                if (!setting.field) {
                    return;
                }

                const column = grid.columns.find(
                    col => col.field === setting.field
                );

                if (!column) {
                    return;
                }

                if (setting.width !== undefined) {
                    column.width = setting.width;
                }

                column.visible = setting.visible !== false;
            });

            grid.refreshColumns();

            const savedFields = settings
                .filter(setting => setting.field)
                .sort((a, b) => a.index - b.index)
                .map(setting => setting.field);
            const currentFields = grid.columns
                .filter(column => column.field)
                .map(column => column.field);

            savedFields.forEach((field, targetIndex) => {
                const currentIndex = currentFields.indexOf(field);

                if (currentIndex === -1 || currentIndex === targetIndex) {
                    return;
                }

                const targetField = currentFields[targetIndex];

                if (!targetField) {
                    return;
                }

                grid.reorderColumns(
                    field,
                    targetField
                );

                currentFields.splice(currentIndex, 1);
                currentFields.splice(targetIndex, 0, field);
            });

            grid.refreshColumns();
        },

        getToolbar() {
            const tools = [
                { text: "Dodaj", prefixIcon: "e-add", id: "add_btn" },
                "Update",
                "Delete",
                "Cancel",
                { text: "Resetuj filtry", prefixIcon: "e-reset", id: "reset_filters" },
                { text: "Zamknij dokument", prefixIcon: "e-lock", id: "close_document" },
                { text: "Zamknij i drukuj", prefixIcon: "e-print", id: "close_and_print" },
                { text: "Search", prefixIcon: "e-search", id: "search", align: "center" },
                { text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' }
            ];
            if (this.hasTableSettingsSel) {
                tools.push({ text: "Usuń ustawienia", prefixIcon: "e-delete", id: "delete-set", align: "right" });
            }
            tools.push(
                { text: "Przywróć domyślny", prefixIcon: "e-undo", id: "restore", align: "right" },
                { text: "Export do Excela", prefixIcon: "e-excelexport", id: "excelexport", align: "right" },
                "ColumnChooser"
            );
            return tools;
        },
        refreshToolbar() {
            const grid = this.$refs.movementsGrid?.ej2Instances;
            if (!grid) return;
            this.toolbar = this.getToolbar();
            grid.toolbar = this.toolbar;
            this.$nextTick(() => {
                this.updateToolbarState();
            });
        },
		updateToolbarState() {
			const grid = this.$refs.movementsGrid?.ej2Instances;
			if (!grid?.toolbarModule) return;
			const canEdit = hasPermission("canViewWarehouseMovements") && !this.isClosed;
			const canAdd = this.canAdd;
			grid.toolbarModule.enableItems(["add_btn"], canAdd);
			grid.toolbarModule.enableItems(["close_document"], canEdit);
			grid.toolbarModule.enableItems(["close_and_print"], canEdit);
			grid.toolbarModule.enableItems(["movementsGridId_update"], canEdit && this.isEditing);
			grid.toolbarModule.enableItems(["movementsGridId_cancel"], canEdit && this.isEditing);
			grid.toolbarModule.enableItems(["movementsGridId_delete"], canEdit && this.hasSelectedRow);
		},
        cellEdit(args) {
            if (!this.isDW()) return;
            const editableFields = ["who_receiving"];
            if (!editableFields.includes(args.column.field)) {
                args.cancel = true;
                Toast.fire({ icon: "info", title: "W dokumencie DW możesz edytować tylko osobę przyjmującą." });
            }
            if (args.rowData.closed === 1 && !this.isAdmin()) {
                args.cancel = true;
                Toast.fire({ icon: "info", title: "Nie można edytować zamkniętego ruchu magazynowego." });
            }
        },
        isDW() {
            return this.selectedDocument?.document_number?.startsWith("DW");
        },
        toggleFullscreen() {
            this.isFullscreen = !this.isFullscreen;
            document.body.style.overflow = this.isFullscreen ? "hidden" : "";
            this.$nextTick(() => {
                this.$refs.movementsGrid?.ej2Instances?.refresh();
            });
        },
        clickToolbarHandler: async function (args) {
            if (args.item.id === "add_btn") {
                if (!this.canAdd) {
                    args.cancel = true;
                    return;
                }
                this.showAddItemMovementModal = true;
                this.$nextTick(() => {
                    this.$refs.addItemMovementModalRef?.show();
                });
                return;
            }
            if (args.item.id === "movementsGridId_delete") {
                const grid = this.$refs.movementsGrid?.ej2Instances;
                if (!grid) return;
                const selectedRecords = grid.getSelectedRecords();
                const closedRow = selectedRecords.find(rec => rec.closed === 1);
                if (closedRow && !this.isAdmin()) {
                    args.cancel = true;
                    await Toast.fire({ icon: "info", title: "Nie można usunąć zamkniętego ruchu magazynowego. W celu usunięcia, zgłoś się do administratora." });
                    return;
                }
            }
            if (args.item.id === "reset_filters") {
                this.$refs.movementsGrid?.ej2Instances?.clearFiltering();
                return;
            }
            if (args.item.id === "save") {
                const grid = this.$refs.movementsGrid?.ej2Instances;
                if (!grid) {
                    console.warn("Grid nie został znaleziony");
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                    return;
                }
                const tableId = "movementsGrid";
                const settings = grid.columns.map((column, index) => ({ field: column.field || null, index, width: column.width, visible: column.visible !== false }));
                try {
                    await axios.post("/table-settings", { tableId, columns: JSON.stringify(settings) });
                    this.hasTableSettingsSel = true;
                    this.refreshToolbar();
                    this.successMsg("Konfiguracja tabeli została pomyślnie zapisana!");
                } catch (error) {
                    console.error("Błąd zapisu:", error.response?.data || error);
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                }
                return;
            }
            if (args.item.id === "delete-set") {
                try {
                    await axios.delete("/table-settings-delete", { data: { tableId: "movementsGrid" } });
                    this.hasTableSettingsSel = false;
                    this.refreshToolbar();
                    this.successMsg("Konfiguracja tabeli została pomyślnie usunięta!");
                } catch (error) {
                    console.error("Błąd usuwania:", error.response?.data || error);
                    this.errorMsg("Konfiguracja tabeli nie została usunięta!");
                }
                return;
            }
            if (args.item.id === "restore") {
                const grid = this.$refs.movementsGrid;
                if (!grid) return;
                const gridName = "grid" + grid.$el.id;
                grid.ej2Instances.enablePersistence = false;
                window.localStorage.setItem(gridName, "");
                grid.ej2Instances.destroy();
                this.applyTableSettings();
                location.reload();
                return;
            }
            if (args.item.id === "excelexport") {
                this.$refs.movementsGrid?.ej2Instances?.excelExport({ fileName: "Stany magazynowe.xlsx" });
                return;
            }
            if (args.item.id === "close_document") {
                if (this.isClosed) return;
                const grid = this.$refs.movementsGrid?.ej2Instances;
                if (!grid) return;
                const records = grid.getCurrentViewRecords();
                if (!records.length) return;
                const ids = records.map(r => r.id);
                const result = await Toast.fire({ toast: false, position: "center", icon: "question", title: "Zamknąć dokument?", html: "Wszystkie pozycje zostaną zamknięte.", showConfirmButton: true, confirmButtonText: "Tak, zamknij", showCancelButton: true, cancelButtonText: "Anuluj" });
                if (!result.isConfirmed) return;
                await axios.post(route("warehouse-movements.close-document"), { document_number: records[0].document_number, movement_ids: ids });
                this.selectedDocument.closed = 1;
                grid.refresh();
                this.$nextTick(() => {
                    this.updateToolbarState();
                });
                return;
            }
            if (args.item.id === "close_and_print") {
                if (this.isClosed) return;
                const grid = this.$refs.movementsGrid?.ej2Instances;
                if (!grid) return;
                const records = grid.getCurrentViewRecords();
                if (!records.length) return;
                const ids = records.map(r => r.id);
                const result = await Toast.fire({ toast: false, position: "center", icon: "question", title: "Zamknąć i wydrukować dokument?", html: "Dokument zostanie zamknięty i otworzy się PDF.", showConfirmButton: true, confirmButtonText: "Tak", showCancelButton: true, cancelButtonText: "Anuluj" });
                if (!result.isConfirmed) return;
                await axios.post(route("warehouse-movements.close-document"), { document_number: records[0].document_number, movement_ids: ids });
                this.selectedDocument.closed = 1;
                grid.refresh();
                this.$nextTick(() => {
                    this.updateToolbarState();
                });
                window.open(route("warehouse-movements.preview-pdf-by-number", { document_number: this.selectedDocument?.document_number }), "_blank");
                return;
            }
        },
        getContextMenu() {
            return [{ text: "Klonuj", target: ".e-content", id: "clone_item" }];
        },
        async clickContextMenuHandler(args) {
            if (args.item.id === "clone_item") {
                this.showAddItemMovementModal = true;
                this.selectedItemToClone = this.$refs.movementsGrid.ej2Instances.getSelectedRecords();
                this.$nextTick(() => {
                    this.$refs.addItemMovementModalRef?.show();
                });
            }
        },
		onRowSelected(args) {
			this.selectedMovement = args.data ?? {};
			this.hasSelectedRow = true;
			this.updateToolbarState();
		},
        actionComplete(args) {
            if (args.requestType === "batchsave") {
                if (args.changes && args.changes.changedRecords) {
                    this.$emit("successMsg", "Dane magazynowe zostały zapisane.");
                } else if (args.error) {
                    this.$emit("errorMsg", "Wystąpił błąd podczas zapisu danych: " + args.error);
                }
            }
        },
        actionFailure(args) {
            const response = args?.error?.[0]?.error;
            if (!response) {
                this.$emit("errorMsg", "Nieznany błąd.");
                return;
            }
            response.text().then(text => {
                try {
                    const json = JSON.parse(text);
                    if (json.errors && Array.isArray(json.errors)) {
                        this.$emit("errorMsg", json.errors[0]);
                    } else {
                        this.$emit("errorMsg", json.message || text);
                    }
                } catch (e) {
                    this.$emit("errorMsg", text);
                }
            }).catch(() => {
                this.$emit("errorMsg", "Nie udało się odczytać błędu z serwera.");
            });
        },
        rowDataBound(args) {
            if (args.data.closed === 1) {
                args.row.style.backgroundColor = "#f5f5f5";
                args.row.style.opacity = 0.4;
            }
        },
        getMovements(newDocument) {
            this.warehouseMovementsDataManager = new DataManager({
                url: route("warehouse-movements.getList", { documentNumber: newDocument.document_number }),
                adaptor: new WebMethodAdaptor(),
                batchUrl: route("warehouse-movements.saveChanges"),
                updateUrl: route("warehouse-movements.updateChanges"),
                crossDomain: true,
                headers: [{ "X-CSRF-TOKEN": usePage().props.csrf_token }]
            });
            if (!this.tableSettingsApplied) {
                this.tableSettingsApplied = true;
                this.applyTableSettings();
            }
            this.$nextTick(() => {
                this.updateToolbarState();
            });
        },
        refreshGrid() {
            this.$refs.movementsGrid?.ej2Instances?.refresh();
        },

        successMsg(resp) {
            Toast.fire({
                position: 'top-end',
                toast: true,
                icon: 'success',
                title: 'Sukces!',
                html: resp,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        },

        errorMsg(resp) {
            Toast.fire({
                position: 'top-end',
                toast: true,
                icon: 'warning',
                title: 'Błąd!',
                html: resp,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        },

        isAdmin() {
            return hasRole("ADMIN");
        }
    }
};
</script>
<style>
.fullscreen-wrapper {
    position: relative;
    transition: all .3s ease-in-out
}

.fullscreen-wrapper.fullscreen {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 20px;
    margin-top: 55px;
    background: #fff;
    overflow: auto;
    transform: scale(1);
    opacity: 1
}

.fullscreen-wrapper {
    transform: scale(.98);
    opacity: .95
}

.fullscreen-wrapper .e-grid .e-toolbar {
    top: 20px !important
}

.fullscreen-wrapper .e-grid .e-gridheader {
    top: 55px !important
}
</style>